module.exports = __webpack_public_path__ + "static/travolta.30e9ccdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/travolta.jpg
// module id = ./src/images/travolta.jpg
// module chunks = 178469467687848